import React from 'react'
import { CollectionTable } from '..'

const Projects = props => (
  <CollectionTable type="project" history={props.history} />
)

export default Projects
